"use client";

import React from "react";
import { Wrench, Disc, Gauge, Battery, Droplets, Settings } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Tire Replacement",
  description: "Wide selection of premium and budget-friendly tires installed by experts.",
  icon: Wrench
}, {
  title: "Flat Tire Repair",
  description: "Fast and reliable puncture repair to get you back on the road safely.",
  icon: Settings
}, {
  title: "Brake Service",
  description: "Comprehensive brake inspections and pad replacements for your safety.",
  icon: Disc
}, {
  title: "TPMS Service",
  description: "Expert sensor calibration and repair for accurate tire pressure monitoring.",
  icon: Gauge
}, {
  title: "Battery Replacement",
  description: "Reliable battery testing and installation for all vehicle makes and models.",
  icon: Battery
}, {
  title: "Oil Change",
  description: "Quick and professional oil changes to keep your engine running smoothly.",
  icon: Droplets
}];
export default function DrainServicesGrid() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="242037" id="freeinspectiontuneup" className="bg-background text-foreground py-16 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center mb-12 transition-all duration-700 ease-out ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-block px-4 py-1 mb-4 rounded-full bg-primary/10 border border-primary/20">
            <span className="text-primary font-bold text-xs uppercase tracking-widest">Professional Care</span>
          </div>
          <h2 className="font-default text-foreground font-bold text-3xl md:text-4xl tracking-tight">
            Our Services
          </h2>
          <p className="mt-4 text-muted-foreground max-w-2xl mx-auto font-default">
            From emergency flat repairs to complete tire replacements, Nova Tire Center provides Los Angeles drivers with expert automotive care and high-performance solutions.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
          {services.map((service, index) => {
          const Icon = service.icon;
          return <Card key={index} data-index={index} className="bg-card border-border border-t-4 border-t-primary rounded-sm shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col h-full">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-sm bg-primary/10 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-primary" aria-hidden="true" />
                  </div>
                  <CardTitle className="font-default text-foreground font-bold text-lg leading-tight">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow pb-6">
                  <CardDescription className="text-muted-foreground text-sm leading-relaxed font-default">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-0 mt-auto">
                  <Button asChild className="w-full bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-[0_0_15px_rgba(249,115,22,0.4)] active:translate-y-0.5 transition-all min-h-[44px] font-default font-bold rounded-sm shadow-md">
                    <Link to="tel:+14243138474">
                      Call Now
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}